module.exports = __webpack_public_path__ + "static/media/galerija_2021 (34).f6406326.jpg";